<template>
	<div>
		<popup-dialog
			v-if="openGallery"
			v-model="openGallery"
		>
			<span slot="header">הוספת מדיה</span>

			<v-form>
				<file-pond
					ref="pond"
					name="test"
					class-name="my-pond"
					label-idle="הוספת קובץ"
					allow-multiple="false"
					accepted-file-types="image/jpeg, image/png"
					check-validity="true"
					:files="myFiles"
					credits="null"
					@init="handleFilePondInit"
					@processfile="endProcessing"
				/>
			</v-form>
			<div class="separator" />
			<v-row>
				<v-col
					v-for="image in existingMedia"
					:key="image.src"
					class="d-flex child-flex"
					cols="2"
				>
					<v-img
						:src="image.imageSrc"
						lazy-src="https://picsum.photos/10/6?image=15"
						aspect-ratio="2"
						class="grey lighten-2"
						@click="updateMediaSrc(image.imageSrc)"
					>
						<template #placeholder>
							<v-row
								class="fill-height ma-0"
								align="center"
								justify="center"
							>
								<v-progress-circular
									indeterminate
									color="grey lighten-5"
								/>
							</v-row>
						</template>
					</v-img>
				</v-col>
			</v-row>
		</popup-dialog>
		<media-gallery-btn @click.native="openGallery =true" />
		<media-gallery-btn
			v-if="selectedImage"
			type="remove"
			@click.native="updateMediaSrc('')"
		/>
	</div>
</template>

<script>
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginFileValidateType
	from "filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js";
import FilePondPluginImagePreview from "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import { types } from "@/store/modules/Media.module";
import MediaGalleryBtn from "./MediaGalleryBtn";

vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

export default {
	name: "MediaGallery",
	components: { MediaGalleryBtn },
	data () {
		return {
			openGallery: false,
			selectedImage: false,
			myFiles: [],
		};
	},
	computed: {
		user () {
			return this.$store.state.AuthModule.user;
		},
		userId () {
			return this.user.id;
		},
		existingMedia () {
			return this.$store.state.MediaModule.medias;
		},
	},
	created () {
		this.$store.dispatch(types.FETCH);
	},
	methods: {
		handleFilePondInit: function () {
		},
		updateMediaSrc (src) {
			this.$emit("selected", src);
			this.selectedImage = src !== "";
			this.openGallery = false;
		},
		endProcessing (e, file) {
			const serverResponse = JSON.parse(file.serverId);
			this.updateMediaSrc(serverResponse.imageSrc);
		},
	},
};
</script>

<style scoped lang="scss">
.separator {
    height: 1px;
    background-color: #1a202c;
    margin: 20px 0;
}
</style>
